import type { Reasons } from '@/constants/reasons'

const reasonLabels: Record<Reasons, string> = {
  'Unknown charge on my card': 'I don’t recognize a payment',
  'Find out what site charged me': 'Identify the website',
  'Request a refund': 'Ask for a refund',
  Other: 'Something else',
}

export const formText = {
  legend: 'What can we help you with?',
  emailLabel: 'Your contact email *',
  emailPlaceholder: 'you@example.com',
  submitLabel: 'Submit enquiry',
  supportLabel: 'Open support chat',
  reasonLabels,
}

export const confirmationText = {
  title: 'Your enquiry has been sent',
  description: 'We’ll email a response within 3 days to:',
  emailNote: 'Need to use a different email?',
  backLabel: 'Submit another enquiry',
  supportLabel: 'Open support chat',
}

export const faqItems = [
  {
    question: 'How can I check an unfamiliar payment?',
    answer: `Contact our support team so we can look into the transaction.
      To help locate it, provide the first 6 and last 4 digits of the card used,
      together with an email address where we can reply. Do not send your full
      card number, security code or password. We’ll review the details and respond by email.`,
  },
  {
    question: 'Why might support ask for the beginning of my card number?',
    answer: `The Bank Identification Number (BIN) is the beginning of a card number
      used to identify its issuer. The first 6 and last 4 digits can help support
      locate a payment. Share only the requested digits through the support channel;
      keep your full card number, security code and passwords private.`,
  },
  {
    question: 'How do I identify the website behind a charge?',
    answer: `Send the transaction details to our support team. We’ll investigate
      the payment and reply with information about the website associated with it.`,
  },
  {
    question: 'How do I ask for a refund?',
    answer: `Refund eligibility depends on applicable law and the Payment and Refund Policy.
      Choose “Ask for a refund” in the enquiry form, or contact support on the website
      where the payment was made. Submitting a request does not guarantee a refund.`,
  },
]
